import React, { useState } from "react";
import InvoiceEntry from "./InvoiceEntry.jsx";
import NavHeightAdjust from "../../../../components/navbar/NavHeightAdjust.jsx";

const InvoiceWizardPage = () => {
  const [formData, setFormData] = useState({
    invoiceNumber: "",
    invoiceDate: "",
    customer: "",
    buildingID: "",
    addressOne: "",
    addressTwo: "",
    city: "",
    state: "",
    zip: "",
    invoiceAmount: "",
    partsAmount: "",
    discountAmount: "",
    taxAmount: "",
  });

  return (
    <NavHeightAdjust>
      <InvoiceEntry formData={formData} setFormData={setFormData} />
    </NavHeightAdjust>
  );
};
export default InvoiceWizardPage;
